module.exports = __webpack_public_path__ + "static/img/xltj.1ce086f1.png";